import {
  createMultiStyleConfigHelpers,
  MultiStyleType,
  StyleThemingProps,
} from '~/utils/chakraUtils'
import { mergeMultiStyleConfig } from '~/utils/styleHelpers'

const DeleteButtonParts = ['iconButton', 'icon'] as const

const helpers = createMultiStyleConfigHelpers(DeleteButtonParts)
export const DeleteButtonStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    iconButton: {
      background: 'transparent',
      _active: {
        background: 'transparent',
        '& > svg': {
          color: 'red.solid',
        },
      },
    },
    icon: {
      color: 'fg.subtle',
      boxSize: '2rem',
      transition: 'color 0.5s ease-in',
    },
  },
})

export const useDeleteButtonStyle = (props?: StyleThemingProps) => {
  return mergeMultiStyleConfig(DeleteButtonStyle, props) as MultiStyleType<
    typeof DeleteButtonParts
  >
}
